/** Token amounts are always grouped, never abbreviated -- 1.2k hides a loss. */
export const formatTokens = (amount: number): string => amount.toLocaleString('en-US');


/**
 * Time left, at the coarsest useful precision.
 *
 * Seconds only matter near the end. Rendering everything as m:ss turned a bet
 * closing in six days into "8689:41", which reads as a broken clock rather than
 * a long wait. Floored at zero rather than going negative.
 */
export const formatCountdown = (msRemaining: number): string => {
    const total = Math.max(0, Math.floor(msRemaining / 1000));

    const days = Math.floor(total / 86_400);
    const hours = Math.floor((total % 86_400) / 3_600);
    const minutes = Math.floor((total % 3_600) / 60);
    const seconds = total % 60;

    if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
